/* app/providers/BreakpointProvider.jsx — раздаёт {bp,...} через контекст,
   ставит data-density на <html> (force comfortable на mobile) и
   data-bp для отладки/стилей. Единственный слушатель resize в дереве. */

import React from 'react';
import { hooks } from '../../hooks/index.jsx';

  const { createContext, useContext, useEffect } = React;
  const { useBreakpoint } = hooks;

  const BreakpointContext = createContext(null);

  function BreakpointProvider({ children }) {
    const value = useBreakpoint();
    const { bp, isMobile } = value;

    useEffect(() => {
      const root = document.documentElement;
      root.setAttribute('data-bp', bp);
      // density: на mobile форсим comfortable (тач-цели); иначе уважаем пользовательский выбор
      const userPref = localStorage.getItem('density');
      if (isMobile) root.setAttribute('data-density', 'comfortable');
      else root.setAttribute('data-density', userPref || 'comfortable');
    }, [bp, isMobile]);

    return <BreakpointContext.Provider value={value}>{children}</BreakpointContext.Provider>;
  }

  const useBp = () => useContext(BreakpointContext);

export { BreakpointProvider };
export { useBp };
